import { SambaTheme, Theme } from "ipctg-inflow-types/InFlowThemes"
import { createContext, useContext } from "react"

import { DocumentThemeMode, ScannedArea } from "../types/local"

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error("useTheme must be used within a <ThemeProvider/>")
  }
  return context
}

interface ContextValue {
  /** The QR lookup ID of the scanned area, if one has been scanned. */
  qrLookupID?: string
  theme?: Theme
  locationInformation?: SambaTheme["locationInformation"]
  welcome?: SambaTheme["welcome"]
  drawer?: SambaTheme["drawer"]
  metadata?: SambaTheme["metadata"]
  setScannedArea: (scannedArea: ScannedArea) => void
  documentThemeMode: DocumentThemeMode
  setDocumentThemeMode: (mode: DocumentThemeMode) => void
}

export const ThemeContext = createContext<ContextValue | undefined>(undefined)

export function getQrLookupIDFromRoute({
  params,
  search,
}: {
  params: unknown
  search: unknown
}) {
  /*
    FML this is super sketch

    Using matches causes other things to break down stream
    for some fucking reason. I think fixing this will take
    some refactoring of how we manage themes which we frankly
    have no time for.
  */

  const qrParam =
    params &&
    typeof params === "object" &&
    "qrLookupID" in params &&
    typeof params.qrLookupID === "string"
      ? params.qrLookupID
      : null

  const qrSearch =
    search &&
    typeof search === "object" &&
    "qrLookupID" in search &&
    typeof search.qrLookupID === "string"
      ? search.qrLookupID
      : null

  return qrParam || qrSearch || null
}
